import React, { useRef, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import dayjs from "dayjs";
import { Paper, Button, Typography } from "@material-ui/core";
import { useFormik } from "formik";
import useStyles from "@/styles/alarmStyle";
import SearchInput from "@/components/SearchInput";
import { useTranslation } from "@/langs/useTranslation";
import { toast } from "@/apis/request";
import { FormItem } from "@/components/Form";
import DateRangePicker from "@/components/DateRangePicker";
import SubmitButton from "@/components/commons/SubmitButton";
import { useGlobalState } from "@/GlobalProvider";
import HasPermission from "@/components/commons/HasPermission";
import { WindowsAppListDatatable } from "./WindowsAppListDatatable";
import { nubisDriveCapacityAPI } from "@/apis/nubisDriveCapacityAPI";
import localforage from "localforage";
import { transformedFormatBytes } from "@/helpers/formatBytesTransformer";
import YourCapacity from "@/components/fileBrowser/YourCapacity";
import styles from "./index.module.less";
import UploadWindowsAppDialog from "./UploadWindowsAppDialog";
import { ReactUnmount } from "@/components/ReactRender";
import * as $ from "jquery";

const WindowsAppList = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const tableRef = useRef(null);
  const selectedIdsRef = useRef([]);
  const isReset = useRef(true);
  const operateType = useRef(null);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const viewDeviceId = useRef(null);
  const expandDataRef = useRef(null);
  const [viewDeviceModalOpen, setViewDeviceModalOpen] = useState(false);

  const [refreshCapacity, setRefreshCapacity] = useState(false);
  const [barValue, setBarValue] = useState(0);
  const [usageValue, setUsageValue] = useState("-");
  const [storageValue, setStorageValue] = useState("-");
  const [isFECHQ, setIsFECHQ] = useState(false);
  const [capacity, setCapacity] = useState({});
  const [companyId, setCompanyId] = useState();
  const [availableStorage, setAvailableStorage] = useState("");

  const [uploadFileDialogOpen, setUploadFileDialogOpen] = useState(false);
  const [data, setData] = useState();
  const [updateAppInfo, setUpdateAppInfo] = useState();

  const getCapacityData = async () => {
    setRefreshCapacity(false);

    let capacityObj = await nubisDriveCapacityAPI();
    let userData = await localforage.getItem("user");
    let companyId = await localforage.getItem("companyId");
    setCompanyId(companyId);
    setCapacity(capacityObj);
    if (capacityObj && userData) {
      let used = transformedFormatBytes(capacityObj.used);
      let total = transformedFormatBytes(capacityObj.total);
      let isParentCompanyNull = !userData.company.parent_company_id;
      let availableStorage = capacityObj.total - capacityObj.used;

      setAvailableStorage(availableStorage);
      setUsageValue(used);

      if (isParentCompanyNull) {
        setIsFECHQ(true);
        setBarValue(Number(capacityObj.used));
        setStorageValue("unlimited");
      } else {
        let percentage = (capacityObj.used / capacityObj.total) * 100;
        setBarValue(percentage);
        setStorageValue(total);
      }

      // stored the available storage for file uploading validation
      await localforage.setItem(
        `${companyId}-availableStorage`,
        availableStorage
      );
    }
  };

  const getAvailableStorageData = async () => {
    if (!isFECHQ) {
      let availableStorage = await localforage.getItem(
        `${companyId}-availableStorage`
      );
      setAvailableStorage(availableStorage);
    } else {
      setAvailableStorage("unlimited");
    }
  };

  useEffect(() => {
    getCapacityData();
    getAvailableStorageData();
  }, []);

  const initialValues = {
    uploadDate: undefined,
    // updateDate: undefined,
    searching: ""
  };

  const history = useHistory();
  const { currentCompanyId } = useGlobalState();

  const { values, handleChange, handleSubmit, handleReset } = useFormik({
    initialValues,
    onSubmit: () => {
      handleReloadDataTable();
    }
  });

  const getSearchParams = () => {
    const formValues = isReset.current ? initialValues : values;
    const { uploadDate, updateDate } = formValues;
    return {
      searching: formValues.keywords,
      // uploadDate: formValues.uploadDate,
      // updateDate: formValues.updateDate,
      start_date:
        uploadDate && uploadDate[0]
          ? dayjs.utc(uploadDate[0]).toISOString()
          : undefined,
      end_date:
        uploadDate && uploadDate[1]
          ? dayjs.utc(uploadDate[1]).toISOString()
          : undefined
    };
  };

  const reloadTableWithGroupId = () => {
    isReset.current = false;
    tableRef.current?.reload();
  };

  const resetTableWithGroupId = () => {
    isReset.current = true;
    tableRef.current?.reload();
  };

  const handleReloadDataTable = reset => {
    // 移除插入的子项避免内存泄漏
    const subApps = Object.values(expandDataRef.current);
    subApps.forEach(subApp =>
      subApp.forEach(tr => {
        ReactUnmount(tr);
        $(tr).remove();
      })
    );
    if (reset) {
      resetTableWithGroupId();
    } else {
      reloadTableWithGroupId();
    }
  };

  const resetQuery = () => {
    handleReset();
    handleReloadDataTable(true);
  };

  const getSelectedIds = () => {
    const selectedIds = tableRef.current.getSelected();
    if (selectedIds && selectedIds.length) {
      selectedIdsRef.current = selectedIds;
      return selectedIds;
    }
    toast.info(t({ defaultMessage: "未选择任何模板" }));
  };

  const handleLoaded = json => {
    setTotal(json.recordsTotal);
  };

  const handleViewDevices = row => {
    viewDeviceId.current = row.id;
    setViewDeviceModalOpen(true);
  };

  const handleUpdateApp = appInfo => {
    setUpdateAppInfo({
      name: appInfo.name,
      package_name: appInfo.package_name,
      package_id: appInfo.package_id,
      version: appInfo.version,
      icon: appInfo.icon
    });
    setUploadFileDialogOpen(true);
  };

  useEffect(() => {
    getCapacityData();
    resetQuery();
  }, [currentCompanyId]);

  return (
    <div className={classes.main}>
      <form onSubmit={handleSubmit}>
        <div style={{ display: "flex", marginBottom: 24 }}>
          <YourCapacity
            capacity={capacity}
            barValue={barValue}
            usageValue={usageValue}
            storageValue={storageValue}
            getCapacityData={getCapacityData}
            refreshCapacity={refreshCapacity}
          />
          <div className={styles.rightAction}>
            <SearchInput
              placeholder={t({ defaultMessage: "搜索" })}
              name="keywords"
              icon={null}
              value={values.keywords}
              onChange={handleChange}
            />
            <HasPermission permission="android_app_management_add_update_file">
              <Button
                variant="contained"
                color="primary"
                style={{ marginLeft: 12 }}
                onClick={() => {
                  setData();
                  setUpdateAppInfo();
                  setUploadFileDialogOpen(true);
                }}
              >
                {t({ defaultMessage: "上传Windows应用程序" })}
              </Button>
            </HasPermission>
          </div>
        </div>
        <Paper elevation={0}>
          <div className={classes.tableHeader}>
            <div className={classes.tableQueryForm}>
              <FormItem
                label={t({ defaultMessage: "上传时间" })}
                className={classes.formItem}
              >
                <DateRangePicker
                  name="uploadDate"
                  value={values.uploadDate}
                  onChange={handleChange}
                />
              </FormItem>
              <FormItem className={classes.formItem}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{ marginRight: 8, width: 100 }}
                >
                  {t({ defaultMessage: "查询" })}
                </Button>
                <Button
                  variant="outlined"
                  onClick={resetQuery}
                  style={{ width: 100 }}
                >
                  {t({ defaultMessage: "重置" })}
                </Button>
              </FormItem>
            </div>
          </div>
          <WindowsAppListDatatable
            ref={tableRef}
            getSearchParams={getSearchParams}
            onView={data => {
              history.push(`/alarm/template/info/${data.id}`);
            }}
            onEdit={data => {
              history.push(`/alarm/template/edit/${data.id}`);
            }}
            onViewDevices={handleViewDevices}
            onLoaded={handleLoaded}
            handleUpdateApp={handleUpdateApp}
            expandDataRef={expandDataRef}
            handleReloadDataTable={handleReloadDataTable}
          />
        </Paper>
      </form>
      <UploadWindowsAppDialog
        companyId={companyId}
        availableStorage={availableStorage}
        getAvailableStorageData={getAvailableStorageData}
        isFECHQ={isFECHQ}
        open={uploadFileDialogOpen}
        data={data}
        setRefreshCapacity={setRefreshCapacity}
        parentId=""
        reloadTable={() => handleReloadDataTable()}
        onClose={() => setUploadFileDialogOpen(false)}
        updateAppInfo={updateAppInfo}
      />
    </div>
  );
};

export default WindowsAppList;
